import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import {
  Body,
  Footer,
  Header,
  Popup,
  Title,
} from '@calendly/ui/components/popup'

export const UnblockConfirmationModal = ({ name, onClose, confirm }) => (
  <Popup onClose={onClose} withCloseButton>
    <Header>
      <Title>{I18n.t('publisher.organization_settings.blocked_sources.unblock_modal.header', { name })}</Title>
    </Header>
    <Body>{I18n.t('publisher.organization_settings.blocked_sources.unblock_modal.description')}</Body>
    <Footer>
      <Button decoration="secondary-outline" onClick={onClose}>
        {I18n.t('publisher.organization_settings.blocked_sources.unblock_modal.cancel')}
      </Button>
      <Button onClick={confirm}>{I18n.t('publisher.organization_settings.blocked_sources.unblock_modal.confirm')}</Button>
    </Footer>
  </Popup>
)
